import { useT } from '../i18n';
import { Button } from '../components/Button/Button';
import { useGo } from '../app/navigation';
import { Header } from './Header';

/** Unknown /claim/* URL. Copy is a DRAFT. */
export function NotFound() {
  const t = useT();
  const go = useGo();
  return (
    <div className="screen" data-screen="not-found">
      <Header stage={null} onBack={() => go('home')} />
      <main className="pane pane--nodock">
        <h1 className="q">{t('common.notFound.title')}</h1>
        <p className="sub">{t('common.notFound.body')}</p>
        <Button onClick={() => go('S1')}>{t('common.notFound.cta')}</Button>
      </main>
    </div>
  );
}
